import { useAppStore } from "@/composables/appStore";
import { LanguageId2LanguageCodeMap } from "@/services/translation";

export function formatNumber(number: number): string {
  const languageId = useAppStore().languageId.value;
  const languageCode = languageId === undefined ? undefined : LanguageId2LanguageCodeMap[languageId];
  return new Intl.NumberFormat(languageCode).format(number);
}

/** The placeholder gettext plural strings carry the count in. */
const CountPlaceholder = "%{count}";

/**
 * Substitutes a locale-formatted count into an already pluralized string.
 *
 * `$ngettext` picks the plural form but interpolates the raw number, so a count that needs grouping
 * ("1 234") has to be formatted first and put in by hand.
 */
export function withFormattedCount(text: string, count: number): string {
  return text.replace(CountPlaceholder, formatNumber(count));
}

/**
 * Make sure min is always lesser than max (or equal).
 * Meaning if min > max, this method returns [ max, min ].
 * If min or max is undefined do not make any changes.
 */
type RangeBoundary = number | undefined;
export function forceAscRangeOrder(min: RangeBoundary, max: RangeBoundary): [RangeBoundary, RangeBoundary] {
  if (min !== undefined && max !== undefined) {
    return min < max ? [min, max] : [max, min];
  } else {
    return [min, max];
  }
}

/**
 * Round given number to given number of decimal places.
 */
export function roundToDecimals(value: number, decimals: number): number {
  const factor = Math.pow(10, decimals);
  return Math.round(value * factor) / factor;
}
